import { kovats } from "../kovats.js";
export function appendKovats(peaks) {
    const result = [];
    for (const peak of peaks) {
        result.push({ ...peak, kovats: kovats(peak.ms) });
    }
    return result;
}
//# sourceMappingURL=append_kovats.js.map